<template>
  <div class="main_style" id="Result">
    <navbar />
    <p class="font-title mx-5 px-5">ผลการบันทึก</p>
    <div
      v-if="this.user.user.group_id < 5"
      class="mx-auto text-center mt-3 mb-4"
      style="width: 50%"
    >
      <b-row>
        <b-col cols="12" offset-xl="3" class="my-3 mx-auto">
          <multiselect
            id="community"
            v-model="community_selected"
            :close-on-select="true"
            :initialValues="community_selected"
            :options="this.communityOption"
            class="multiselect-style2 custom-multiselect text-left"
            deselect-label="ยกเลิก"
            label="name"
            placeholder="ชุมชน"
            select-label=""
            selectedLabel=""
            track-by="id"
            @input="getResult"
          ></multiselect>
        </b-col>
      </b-row>
    </div>

    <b-row>
      <b-col
        xl="5"
        offset-xl="3"
        lg="6"
        offset-lg="2"
        sm="10"
        offset-sm=" 1"
        class="my-3"
      >
        <b-form-group
          label=""
          label-for="filter-input"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          class="mb-0"
        >
          <b-input-group size="md">
            <b-form-input
              id="filter-input"
              v-model="filter"
              type="search"
              placeholder="ค้นหา"
              style="border-radius: 15px"
              class="w-50"
            ></b-form-input>

            <b-input-group-append>
              <button
                class="mx-0"
                pill
                style="
                  background-color: #3b5286;
                  color: white;
                  width: 100%;
                  border-radius: 15px;
                "
                :disabled="!filter"
                @click="filter = ''"
              >
                ล้างค่า
              </button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col cols="2" style="padding-top: 30px">
        ผลการค้นหา {{ items.length }} รายการ
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <b-table
          :filter="filter"
          :fields="fields"
          :items="this.items"
          :per-page="perPage"
          :current-page="currentPage"
          class="mx-auto"
          hover
          responsive="md"
        >
          <template #cell(no)="row">
            {{ row.index + 1 + (currentPage - 1) * 10 }}
          </template>
          <template #cell(code)="row">
            <a
              class="text-orange"
              style="color: black"
              @click="openEditResultForm(row.item.code, row.item.status)"
              >{{ row.item.code }}</a
            >
          </template>
          <template #cell(category)="row">
            {{ row.item.category }}
          </template>
          <template #cell(status)="row">
            <b-row v-if="user.user.group_id == 2" class="text-center">
              <multiselect
                id="survey"
                v-model="statusSelected[row.item.code]"
                :options="statusOption"
                class="multiselect-style2 custom-multiselect"
                deselect-label="ยกเลิก"
                label="name"
                placeholder="สถานะ "
                select-label=""
                selectedLabel=""
                track-by="name"
                @input="editStatus(row.item, statusSelected[row.item.code].id)"
              ></multiselect>
            </b-row>
            <b-row v-else class="text-center">
              <b-col cols="12">
                <img :src="getImgPath(row.item.status)" />
              </b-col>
              <b-col cols="12"> {{ getStatusname(row.item.status) }}</b-col>
            </b-row>
          </template>
          <template #cell(publish)="row">
            <template
              v-if="user.user.group_id == 2 && row.item.status == 3"
              class="text-center"
            >
              <multiselect
                id="publish"
                v-model="publishSelected[row.item.code]"
                :options="publishOption"
                class="multiselect-style2 custom-multiselect"
                deselect-label="ยกเลิก"
                label="name"
                placeholder="การเผยแพร่"
                select-label=""
                selectedLabel=""
                track-by="name"
                @input="
                  editPublish(row.item, publishSelected[row.item.code].id)
                "
              ></multiselect>
            </template>
            <template v-else>
              <div v-if="row.item.status !== 2">{{ row.item.publish }}</div>
            </template>
          </template>
          <template #cell(action)="row">
            <a
              class="text-orange pointer"
              style="color: black; font-weight: 900"
              @click="openEditResultForm(row.item.code, row.item.status)"
            >
              เปิด
            </a>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <div class="mt-3" v-if="rows > perPage">
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="my-table"
        align="center"
        first-number
        last-number
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import navbar from "@/components/navbar";
import icon_verify from "@/assets/icons/icon_progress/icon_verify.svg";
import icon_unapprove from "@/assets/icons/icon_progress/icon_unapprove.svg";
import icon_approve from "@/assets/icons/icon_progress/icon_approve.svg";
import { mapState } from "vuex";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";

export default {
  name: "Result",
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      categoriesOption: [],
      plant_lists: [],
      icon_verify: icon_verify,
      icon_unapprove: icon_unapprove,
      icon_approve: icon_approve,
      community_selected: [],
      communityOption: [],
      items: [],
      fields: [
        { key: "no", label: "ลำดับ" },
        { key: "code", label: "รหัสข้อมูล", sortable: true },
        { key: "name_bio", label: "ชื่อพืช", sortable: true },
        { key: "category", label: "กลุ่มชนิดพืช", sortable: true },
        { key: "type_plant", label: "ประเภทแปลง", sortable: true },
        { key: "community", label: "ชื่อชุมชน", sortable: true },
        { key: "date", label: "วันที่บันทึก", sortable: true },
        { key: "status", label: "สถานะ", sortable: true },
        { key: "publish", label: "การเผยแพร่", sortable: true },
        { key: "action", label: "เปิดดู" },
      ],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      statusOption: [],
      statusSelected: [],
      publishOption: [],
      publishSelected: [],
      config: {
        server_mode: true,
        preservePageOnDataChange: true,
        loaderText: "Updating...",
        pagination: false, // default true
        pagination_info: true, // default true
        show_refresh_button: false, // default is also true
        show_reset_button: false, // default is also true
        global_search: { placeholder: "ค้นหา" },
      },
    };
  },
  components: { navbar, Multiselect },
  created() {
    this.prepareData();
  },
  computed: {
    ...mapState({
      plants_survey: (state) => state.plantsModule.plants_survey,
      plants_bank: (state) => state.plantsModule.plants_bank,
      categories: (state) => state.OptionsModule.categories,
      community: (state) => state.OptionsModule.community,
      status: (state) => state.OptionsModule.status,
      publish: (state) => state.OptionsModule.publish,
      list_save: (state) => state.plantsModule.list_save,
      user: (state) => state.AuthModule.userData,
      accessToken: (state) => state.AuthModule.accessToken,
      form: (state) => state.formSurveyModule.form,
    }),
    rows() {
      return this.items.length;
    },
  },
  mounted() {
    if (!this.community_selected.id) {
      this.items = [];
    }
    this.status.forEach((item) => {
      this.statusOption.push({
        id: item.status_id,
        name: item.name,
      });
    });
    this.publish.forEach((item) => {
      this.publishOption.push({
        id: item.status_code,
        name: item.status,
      });
    });
  },
  methods: {
    prepareData() {
      if (this.user.user.group_id == 5) {
        let data = {
          type: 1,
          community_id: this.user.user.community_id,
          token: this.accessToken,
        };
        Swal.fire({
          title: "ระบบกำลังทำงาน",
          html: "โปรดรอสักครู่...",
          allowEscapeKey: false,
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
            this.$store
              .dispatch("plantsModule/getAllPlants", data)
              .then((res) => {
                if (res) {
                  this.generateTable();
                }
              });
          },
        });
      } else {
        let data = 0;

        if (this.user.user.group_id == 4) {
          data = this.user.user.community_id;
        }

        Swal.fire({
          title: "ระบบกำลังทำงาน",
          html: "โปรดรอสักครู่...",
          allowEscapeKey: false,
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
            this.$store
              .dispatch("OptionsModule/onGetCommunityOption", data)
              .then(() => {
                this.communityOption.push({
                  id: 0,
                  name: "ทุกชมชน",
                });
                this.community.forEach((item) => {
                  this.communityOption.push({
                    id: item.community_id,
                    name: item.name,
                  });
                });
                this.categories.forEach((item) => {
                  this.categoriesOption.push({
                    id: item.category_id,
                    name: item.name,
                  });
                });
                Swal.clickConfirm();
              });
          },
        });
      }
    },
    getResult() {
      //for admin can view all ; professor can see in our list
      //this.community_selected.id == 0 is all result
      if (this.community_selected.id || this.community_selected.id == 0) {
        if (this.user.user.group_id != 4) {
          this.user.user.community_id = this.community_selected.id;
        } else {
          return this.getResultAllForProfessor();
        }
        let data = {
          type: 1,
          community_id: this.user.user.community_id,
          token: this.accessToken,
        };
        setTimeout(() => {
          Swal.fire({
            title: "ระบบกำลังทำงาน",
            html: "โปรดรอสักครู่...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
              this.$store
                .dispatch("plantsModule/getAllPlants", data)
                .then(() => {
                  this.items = [];
                  this.generateTable();
                });
            },
          });
        }, 500);
      }
    },
    getImgPath(code) {
      switch (code) {
        case 2:
          return this.icon_verify;
        case 3:
          return this.icon_approve;
        case 4:
          return this.icon_unapprove;
      }
    },
    generateTable() {
      if (this.plants_survey.length > 0) {
        this.plants_survey.forEach((item) => {
          let data = {
            // select:
            //   '</b-input-group><b-checkbox :value=`${item.id}` v-model="plant_lists"></b-checkbox></<b-input-group>',
            code: item.plants.plant_code,
            name_bio: item.plants.bio_name,
            name_plant: item.survey_plot_name,
            category: this.getCategoryName(item.plants.category_id),
            type_plant: "แปลงสำรวจ",
            community: item.plants.community,
            date: item.survey_date,
            status: item.plants.status_id,
            publish: item.plants.publish,
          };
          this.items.push(data);
        });
      }
      if (this.plants_bank.length > 0) {
        this.plants_bank.forEach((item) => {
          let data = {
            // select: "",
            code: item.plants.plant_code,
            name_bio: item.plants.bio_name,
            name_plant: item.survey_plot_name,
            category: this.getCategoryName(item.plants.category_id),
            type_plant: "แปลงสำรวจ,แปลงธนาคาร",
            community: item.plants.community,
            date: item.bank_date,
            status: item.plants.status_id,
            publish: item.plants.publish,
          };
          this.items.push(data);
        });
      }
      if (this.user.user.group_id == 2) {
        this.items.forEach((list, i) => {
          let status_filter = this.status.find((data_status) => {
            return data_status.status_id == list.status;
          });
          this.statusSelected[list.code] = {
            id: list.status,
            name: status_filter.name,
          };
          if (list.publish) {
            let publish_filter = this.publish.find((data_status) => {
              return data_status.status == list.publish;
            });
            this.publishSelected[list.code] = {
              id: publish_filter.status_code,
              name: list.publish,
            };
          }
        });
      }
      Swal.clickConfirm();
    },
    getCategoryName(id) {
      let name = this.categories.filter((item) => {
        return item.category_id == id;
      });
      return name[0].name;
    },
    getStatusname(id) {
      switch (id) {
        case 2:
          return "กำลังตรวจสอบ";
        case 3:
          return "อนุมัติ";
        case 4:
          return "ไม่อนุมัติ";
      }
    },
    openEditResultForm(code, status) {
      Swal.fire({
        title: "ระบบกำลังทำงาน",
        html: "โปรดรอสักครู่...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      this.$store.dispatch("formSurveyModule/getForm", code).then((res) => {
        if (res.code == 200) {
          if (this.user.user.group_id != 5 && status <= 2) {
            this.$router.push("/Form");
          } else {
            this.$router.push("/plantInfo");
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "ผิดพลาด!",
            text: "ไม่พบข้อมูล",
          });
        }
      });
    },
    //for role admin can edit status id and public id
    async editStatus(item_change, status_id) {
      //APPROVE
      Swal.fire({
        title: "ระบบกำลังทำงาน",
        html: "โปรดรอสักครู่...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch("formSurveyModule/getForm", item_change.code)
            .then((res) => {
              if (res.code == 200) {
                console.log("status", this.form.status_id);
                this.form.status_id = status_id;
              }

              this.form.publish_status = null;

              setTimeout(() => {
                Swal.fire({
                  title: "ยืนยันการเปลี่ยนสถานะ?",
                  icon: "warning",
                  showCancelButton: true,
                  cancelButtonText: "ยกเลิก",
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "ตกลง",
                }).then((result) => {
                  if (result.isConfirmed) {
                    this.saveEditStatus();
                  }
                });
              }, 500);
            });
        },
      });
    },
    async editPublish(item_change, publish_status) {
      Swal.fire({
        title: "ระบบกำลังทำงาน",
        html: "โปรดรอสักครู่...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch("formSurveyModule/getForm", item_change.code)
            .then((res) => {
              if (res.code == 200) {
                this.form.publish_status = publish_status;
                if (this.form.status_id !== 3) {
                  this.form.publish_status = 0;
                }

                setTimeout(() => {
                  Swal.fire({
                    title: "ยืนยันการเปลี่ยนสถานะ?",
                    icon: "warning",
                    showCancelButton: true,
                    cancelButtonText: "ยกเลิก",
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "ตกลง",
                  }).then((result) => {
                    if (result.isConfirmed) {
                      this.saveEditStatus();
                    }
                  });
                }, 500);
              }
            });
        },
      });
    },

    async saveStatus(plant_code, status_id) {
      Swal.fire({
        title: "ระบบกำลังทำงาน",
        html: "โปรดรอสักครู่...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch("formSurveyModule/getForm", plant_code)
            .then((res) => {
              if (res.code == 200) {
                this.form.status_id = status_id;
                //this.saveEditStatus();
              }
            });
        },
      });
    },
    async confirmPublish() {
      const inputOptions = new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            0: "ไม่เผยแพร่",
            1: "เผยแพร่",
          });
        }, 1000);
      });

      const value = await Swal.fire({
        title: "การเผยแพร่?",
        input: "radio",
        inputOptions: inputOptions,
        allowEscapeKey: false,
        allowOutsideClick: false,
        cancelButtonText: "ยกเลิก",
        confirmButtonText: "ตกลง",
        cancelButtonColor: "#FF0000",
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) {
            return "โปรดเลือกการเผยแพร่!";
          } else {
            this.form.publish_status = value;
          }
        },
      });
    },
    saveEditStatus() {
      Swal.fire({
        title: "ระบบกำลังทำงาน",
        html: "โปรดรอสักครู่...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          if (this.user.user.community_id == 0) {
            this.user.user.community_id = this.form.community_id;
          }
          let data = {
            data: this.form,
            user: this.user.user,
            token: this.accessToken,
          };
          this.$store
            .dispatch("formSurveyModule/onSaveForm", data)
            .then((res) => {
              if (res.code == 200) {
                this.plants_bank = [];
                this.plants_survey = [];
                this.items = [];
                this.getResult();
                Swal.clickConfirm();
              }
            });
        },
      });
    },
    getResultAllForProfessor() {
      // 0 is all plant of community
      let professor_select_community = "";
      if (this.community_selected.id == 0) {
        professor_select_community = this.user.user.community_id;
      } else {
        professor_select_community = this.community_selected.id;
      }
      let data = {
        type: 1,
        community_id: professor_select_community,
        group_id: this.user.user.group_id,
        token: this.accessToken,
      };
      setTimeout(() => {
        Swal.fire({
          title: "ระบบกำลังทำงาน",
          html: "โปรดรอสักครู่...",
          allowEscapeKey: false,
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
            this.$store
              .dispatch("plantsModule/getAllPlantsForProfessor", data)
              .then(() => {
                this.items = [];
                this.generateTable();
              });
          },
        });
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-form {
  background-color: white;
  border: none;
}
html,
body {
  overflow-x: hidden !important;
  height: 100%;
  min-height: 80vh;
}
</style>
